import { indexItems } from '@/mocks/index';

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-2">
            专题索引
          </h2>
          <p className="text-sm text-foreground-500">快速找到你感兴趣的娱乐内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-300 hover:bg-primary-50/30 transition-all group cursor-pointer"
            >
              <div className="flex items-start gap-3">
                <div className="w-11 h-11 rounded-lg bg-accent-100/80 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                  <i className={`${item.icon} text-lg text-accent-600`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <h3 className="text-sm font-bold text-foreground-900">{item.name}</h3>
                    <span className="text-[10px] text-foreground-400 bg-background-100 px-1.5 py-0.5 rounded-full whitespace-nowrap">
                      {item.count}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}